export default __webpack_public_path__ + "static/media/pic1.c19f474b.png";